import { render } from "./ApexDonut.vue?vue&type=template&id=59d3ea06"
import script from "./ApexDonut.vue?vue&type=script&setup=true&lang=js"
export * from "./ApexDonut.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Helpers/ApexDonut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59d3ea06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59d3ea06', __exports__)) {
    api.reload('59d3ea06', __exports__)
  }
  
  module.hot.accept("./ApexDonut.vue?vue&type=template&id=59d3ea06", () => {
    api.rerender('59d3ea06', render)
  })

}


export default __exports__